import { useEffect, useState } from "react";
import { BadgePercent } from "lucide-react";
import { api } from "@/lib/api";

export function useAgentPct() {
  const [pct, setPct] = useState(0);
  useEffect(() => { api.get("/billing/agent-discount").then((r) => setPct(r.data.percent)).catch(() => {}); }, []);
  return pct;
}

export default function AgentDiscountNote({ testid = "agent-discount-note", children }) {
  const pct = useAgentPct();
  if (!pct) return null;
  return (
    <div className="flex items-start gap-2 text-xs rounded-lg border border-emerald-500/30 bg-emerald-500/5 text-emerald-700 px-3 py-2" data-testid={testid}>
      <BadgePercent className="h-4 w-4 shrink-0" />
      <span>Marketing Agent discount: <b>{pct}% off</b> is applied automatically at checkout, before tax. {children || "It does not apply to Meta ad spend, taxes or third-party charges. A coupon is combined with it only if the coupon allows it; otherwise you get whichever saves more."}</span>
    </div>
  );
}
